import { Constants } from '@/utils/constants';
import { atom } from 'recoil';
import persistAtom from './recoilPersist';

/**
 * オプション申込フローで次画面へ引き継ぐ入力情報。
 * オプションごとに必要な追加パラメータが異なるため、共通枠の中に個別情報をぶら下げて保持する。
 */
export type EntryOptionInfoStateType = {
  option_name: string;
  parameters: {
    option_info: {
      option_code: string;
      order_type: number;
      unext_option_info: { change_type: number; program_guid: number } | undefined;
      amuelink_option_info: { contract_no: number } | undefined;
      ps5_option_info: { lease_quit_type: number } | undefined;
      bravia_option_info: { lease_quit_type: number } | undefined;
      smartlife_option_info:
        | {
            onu_preferred_delivery_date: string;
            onu_preferred_delivery_time_zone: string;
            onu_preferred_date: string;
            onu_preferred_time_zone: string;
          }
        | undefined;
      tngr_mesh_wifi_option_info:
        | { preferred_date: string; preferred_time_zone: string }
        | undefined;
      nuro_denki_option_info: { plan: number } | undefined;
    };
    contract_data_delivery_agreement: boolean | undefined;
  };
};

/**
 * オプション申込対象と付随パラメータを保持する state。
 * 一覧画面から入力・確認・完了画面まで同じ申込情報を引き回せるようにセッションへ保持する。
 */
export const EntryOptionInfoState = atom<EntryOptionInfoStateType>({
  key: 'EntryOptionInfoState',
  default: {
    option_name: '',
    parameters: {
      option_info: {
        option_code: '',
        order_type: Constants.OptionOrderType.SIMPLE_ENTRY,
        unext_option_info: undefined,
        amuelink_option_info: undefined,
        ps5_option_info: undefined,
        bravia_option_info: undefined,
        smartlife_option_info: undefined,
        tngr_mesh_wifi_option_info: undefined,
        nuro_denki_option_info: undefined,
      },
      contract_data_delivery_agreement: undefined,
    },
  },
  effects_UNSTABLE: [persistAtom],
});

export default EntryOptionInfoState;
